
import React from 'react';
import { FormField } from '@/components/ui/form';
import TermsCheckbox from '@/components/auth/TermsCheckbox';
import { SignupFormField } from '@/utils/config/types';
import { UseFormReturn } from 'react-hook-form';

interface CheckboxFieldProps {
  field: SignupFormField;
  form: UseFormReturn<any>;
}

const CheckboxField = ({ field, form }: CheckboxFieldProps) => {
  return (
    <FormField
      key={field.name}
      control={form.control}
      name={field.name}
      render={({ field: formField }) => (
        <TermsCheckbox 
          field={formField} 
          label={field.label}
          required={field.required}
        />
      )}
    />
  );
};

export default CheckboxField;
